import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMultiLineText = styled(Box)({
  p: {
    margin: 0,
  },
});
